import React, { useEffect, useRef } from 'react';
import { ArrowRight, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { logBriefShown } from '@/components/utils/analytics';

function isResearchBriefItem(item) {
  return !item?.personName;
}

export default function ChatMorningBriefMessage({
  message,
  onChipClick,
  disabled,
  eventTracking,
  showChips = true,
}) {
  const loggedRef = useRef(null);
  const briefId = message?.id || 'morning-brief';
  const tenantId = eventTracking?.tenantId;
  const userId = eventTracking?.userId;

  useEffect(() => {
    if (!tenantId || !userId || loggedRef.current === briefId) return;
    loggedRef.current = briefId;
    void logBriefShown({
      tenantId,
      userId,
      briefType: 'morning',
      source: 'chatbot',
      metadata: {
        brief_id: briefId,
        item_count: Array.isArray(message?.briefItems) ? message.briefItems.length : 0,
      },
    });
  }, [briefId, tenantId, userId, message?.briefItems]);

  const intro = message?.text || '';
  const items = Array.isArray(message?.briefItems) ? message.briefItems : [];

  return (
    <div className="space-y-4">
      {intro ? <p className="text-sm text-[#0A1A2F] mb-0">{intro}</p> : null}
      {items.map((item, index) => {
        const key = item.id || `${item.accountName}-${index}`;
        const isResearch = isResearchBriefItem(item);
        return (
          <div
            key={key}
            className={`${index > 0 ? 'pt-4 border-t border-gray-200/80' : ''} ${
              isResearch ? 'rounded-md bg-slate-50 -mx-1 px-2 py-2' : ''
            }`}
          >
            {isResearch ? (
              <p className="text-[10px] font-semibold uppercase tracking-wide text-[#7A8694] mb-1.5">
                Research
              </p>
            ) : null}
            {item.accountName ? (
              <p className="text-sm font-semibold text-[#0A1A2F] mb-1">{item.accountName}</p>
            ) : null}
            {item.sentence ? (
              <p className="text-sm text-[#0A1A2F] leading-relaxed mb-2 flex items-start gap-1.5">
                {isResearch ? (
                  <Search className="w-3.5 h-3.5 text-[#7A8694] shrink-0 mt-0.5" aria-hidden />
                ) : null}
                <span>{item.sentence}</span>
              </p>
            ) : null}
            {showChips && item.chipLabel ? (
              <Button
                type="button"
                variant="outline"
                className="w-full h-auto min-h-9 py-2 px-3 text-sm whitespace-normal justify-between gap-2 border-gray-300 hover:bg-white hover:border-[#00C2C2] text-[#0A1A2F]"
                disabled={disabled}
                onClick={() => onChipClick?.(item, message)}
              >
                <span className="text-left">{item.chipLabel}</span>
                <ArrowRight className="w-4 h-4 shrink-0 text-[#5C6B7A]" aria-hidden />
              </Button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
